import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ProjectDetails } from '@/app/interfaces/project';
import { ReviewFieldsService } from '@/app/services/ia-services/review-fields.service';
import { ReviewFieldKey } from '@/app/interfaces/review-fields.types';
import { TooltipComponent } from '@/app/shared/tooltip/tooltip.component';
import { SpanishDatePipe } from '../../../../../pipe/date.pipe';

type PersonalSelectedDataType =
  | 'si'
  | 'no'
  | 'anonimizados'
  | 'parcial_seudonimizados'
  | 'total_seudonimizados';

@Component({
  selector: 'app-project-input-data',
  standalone: true,
  imports: [CommonModule, TooltipComponent, SpanishDatePipe],
  templateUrl: './project-input-data.component.html',
})
export class ProjectInputDataComponent {
  @Input() project: ProjectDetails | null = null;
  @Input() reviewMode = false;
  @Input() readonlyReview = false;
  @Input() showPreviousReviewIndicators = false;

  constructor(public reviewFields: ReviewFieldsService) {}

  readonly personalSelectedDataTypeLabels: Record<PersonalSelectedDataType, string> = {
    si: 'Sí',
    no: 'No',
    anonimizados: 'Datos anonimizados previamente',
    parcial_seudonimizados: 'Parcialmente seudonimizado',
    total_seudonimizados: 'Totalmente seudonimizados',
  };

  readonly categoryMap: Record<string, string> = {
    noPI: 'No especial protección',
    salud: 'Datos de salud',
    etnicoRacial: 'Origen étnico o racial',
    opiniones: 'Opiniones políticas, religiosas, sindicales',
    geneticosBiometricos: 'Datos genéticos o biométricos',
    orientacionSexual: 'Vida sexual u orientación',
  };
  // Getter para dar formato a categoryDataPersonalSelected, que es un Array
  get categoryDataPersonalSelectedText(): string {
    const categories = this.project?.categoryDataPersonalSelected;
    if (!categories || categories.length === 0) {
      return '-';
    }

    return categories.map((cat) => this.categoryMap[cat] ?? cat).join(', ');
  }

  previousReviewText(fieldKey: ReviewFieldKey): string {
    return this.reviewFields.getPreviousReviewTooltipText(fieldKey);
  }

  personalSelectedDataTypeLabel(value: ProjectDetails['personalSelectedDataType']): string {
    if (!value) {
      return '-';
    }

    return this.isPersonalSelectedDataType(value) ? this.personalSelectedDataTypeLabels[value] : value;
  }

  private isPersonalSelectedDataType(value: string): value is PersonalSelectedDataType {
    return value in this.personalSelectedDataTypeLabels;
  }
}
